import { createFileRoute } from '@tanstack/react-router';
import * as React from 'react';
import { useTranslations } from 'use-intl';

import { PageHeader } from '@/components/dashboard/page-header';
import { ProjectsListClient } from '@/components/project/projects-list-client';

export const Route = createFileRoute('/_app/projects/')({
  component: ProjectsPage,
});

function ProjectsPage(): React.ReactElement {
  const t = useTranslations('project.list');
  return (
    <>
      <PageHeader title={t('title')} subtitle={t('subtitle')} />
      <ProjectsListClient />
    </>
  );
}
